import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { ClinicalStaffComponent } from './clinical-staff/clinical-staff.component';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { ServicesComponent } from './services/services.component';
import { ServicesDetailsComponent } from './services/services-details/services-details.component';
import { TipsComponent } from './tips/tips.component';
import { TipsDetailsComponent } from './tips/tips-details/tips-details.component';


const routes: Routes = [
    {   path: '',
        component: HomeComponent,
	},
	{
		path : 'sobre-o-hospital',
		component: AboutComponent
	},
	{
		path : 'corpo-clinico',
		component: ClinicalStaffComponent
	},
	{
		path : 'servicos',
		component: ServicesComponent
	},
	{
		path : 'servicos/:slug',
		component: ServicesDetailsComponent
	},
	{
		path : 'dicas-informacoes',
		component: TipsComponent
	},
	{
        path: 'dicas-informacoes/:slug',
		component: TipsDetailsComponent,
	},
	{
		path : 'contato',
		component: ContactComponent
	}

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: false})],
    exports: [RouterModule]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/app.routing.module.ts